import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class AppErrorHandler implements ErrorHandler {

  handleError(error: unknown): void {
    const message = this.describe(error);
    console.error(message, error);
  }

  private describe(error: unknown): string {
    if (error instanceof Error) {
      return error.stack || error.message;
    }
    if (error && typeof error === 'object') {
      const wrapped = error as { message?: string; rejection?: unknown; stack?: string };
      if (wrapped.rejection) {
        return this.describe(wrapped.rejection);
      }
      if (typeof wrapped.message === 'string') {
        return wrapped.stack || wrapped.message;
      }
      try {
        return JSON.stringify(error);
      } catch {
        return String(error);
      }
    }
    return String(error);
  }
}
